import React from "react";
import { motion } from "framer-motion";
import aboutimg from "../Images/about-us.png";
import Counter from "../Comoponents/Counter";
import { useTranslation, Trans } from "react-i18next";

function About() {
  const { t, i18n } = useTranslation();
  const isMobile = window.innerWidth < 768;

  const APPLE_LINK =
    "https://apps.apple.com/us/developer/emad-ramzy/id1699778983";
  const ANDROID_LINK = "https://play.google.com/store/apps/developer?id=Emadr";

  const handleAppRedirect = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      //Android
      window.location.href = ANDROID_LINK;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      //iPhone/iPad
      window.location.href = APPLE_LINK;
    } else if (/Mac/i.test(userAgent)) {
      // Mac
      window.location.href = APPLE_LINK; 
    } else {
      // Windows / others
      window.location.href = ANDROID_LINK; 
    }
  };
  return (
    <div>
      <div className="about-section-wrapping pb-60" id="about">
        <div className="container">
          <div className="row">
            <motion.div
              className="col-md-6 about-sec-wrap"
              initial={isMobile ? false : { opacity: 0, x: -40 }}
              whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="main-heading">
                <Trans i18nKey="about_heading">
                  Every journey deserves a better <span> experience </span>{" "}
                </Trans>{" "}
              </h2>{" "}
              <p> {t("about_desc")} </p>{" "}
              <button className="wave-btn" onClick={handleAppRedirect}>
                {t("about_btn")}
              </button>
              {/* <div className="d-flex gap-5 mt-4 about-count-wrap">
                            <div className="d-flex flex-column">
                              <h5 className="about-count">{t("rides_completed")}</h5>
                              <span className="about-series">
                                <Counter end={10000} suffix="+" />
                              </span>
                            </div>

                            <div className="d-flex flex-column">
                              <h5 className="about-count">{t("active_drivers")}</h5>
                              <span className="about-series">
                                <Counter end={500} suffix="+" />
                              </span>
                            </div>

                            <div className="d-flex flex-column">
                              <h5 className="about-count">{t("user_rating")}</h5>
                              <span className="about-series">
                                <Counter end={4.8} decimals={1} suffix="★" />
                              </span>
                            </div>
                          </div> */}{" "}
            </motion.div>
            <motion.div
              className="col-md-6"
              initial={isMobile ? false : { opacity: 0, x: 40 }}
              whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <img className="img-fluid" src={aboutimg} />{" "}
            </motion.div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
}

export default About;
